import { ChangeDetectorRef, Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { TimeOffService } from '@app/main/time-off/services/time-off.service';
import { AppConsts } from '@shared/AppConsts';
import { CommonCacheServiceProxy, FilerMeberDataDto, GetAllProjectDto, ProjectServiceProxy, ProjectType, ProjectType5, UserListDto, UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { AbpSessionService } from 'abp-ng2-module';
import { Console } from 'console';
import _ from 'lodash';
import { finalize, map } from 'rxjs/operators';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ConstRoleName } from '@shared/ConstRoleNames';
import { debugPort } from 'process';
@Component({
    selector: 'app-member-filter',
    templateUrl: './member-filter.component.html',
    styleUrls: ['./member-filter.component.css']
})
export class MemberFilterComponent extends AppComponentBase implements OnInit {

    items: FilerMeberDataDto[]=[];
    @Output() change = new EventEmitter<UserListDto[]>();
    @Input() inputUseritems: UserListDto[];
    noDataFound: boolean = false;
    // Input properties
    @Input() multiselect: boolean;
    @Input() closeOnSelect: boolean;
    @Input() placeholder: string;
    @Input() shortName: boolean;
    @Input() roleName: boolean;
    @Input() incomingProjectsIds: number[];
    @Input() AddTimeOff: boolean = false;
    @Input() isdisabled: boolean;
    // Non input properties
    bindLabel: string = "emailAddress";
    @Input() selectedItems: any;
    selectedItemsLength:number=0;
    isOpen: boolean;
    loading: boolean = false;
    showselectall: boolean = true;
    showdeselectall: boolean = false;
    assignedUserIdFilter: number[];
    projectsData: GetAllProjectDto[];
    projectIds: number[] = [];
    membersList: UserListDto[] = [];
    userRoleArray: string[];
    isEmployee:boolean;
    constructor(
        private _userServiceProxy: UserServiceProxy,
        private timeOffService: TimeOffService,
        private _abpSessionService: AbpSessionService,
        private _commonCacheServiceProxy: CommonCacheServiceProxy,
        injector:Injector,
        private _projectServiceProxy: ProjectServiceProxy,) {
            super(injector);
    }

    async ngOnInit() {
        this.selectedItems = this.inputUseritems;
        this.loading = true;
       /* (filter: string | null | undefined, permissions: string[] | null | undefined, role: number | null | undefined, roleArray: number[] | null | undefined, onlyLockedUsers: boolean | undefined, isAllUserDisplay: boolean | undefined, organizationUnit: OrganizationUnitDto[] | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined
        input.filter = undefined;*/

        this.getAllProjects();

        // this.items = await this._userServiceProxy.filterByMemberData(inputData).pipe(map(r => r.items)).toPromise();

        this.loading = false;
    }

    // ngOnChanges() {

    //     this.selectedItems = this.inputUseritems;

    // }

    async getAllProjects() {

        this.userRoleArray = AppConsts.userRoleArray;
        this.isEmployee = this.userRoleArray.includes(ConstRoleName.User);
        if(this.AddTimeOff){
            const isUserAdmin = this.userRoleArray.includes(ConstRoleName.Admin);
            const isUserManager = this.userRoleArray.includes(ConstRoleName.ProjectManager);
            const isUserPrManager = this.userRoleArray.includes(ConstRoleName.ProgramManager);
            const isUserSuper = this.userRoleArray.includes(ConstRoleName.SuperAdmin);

            if (isUserAdmin || isUserSuper) {
                this.items = await this._commonCacheServiceProxy.filterByMemberData().toPromise();
            }
            else if(isUserManager||isUserPrManager){
                this.assignedUserIdFilter = [];
                this.projectsData = [];
                this.assignedUserIdFilter.push(this._abpSessionService.userId);
                let res = await this._projectServiceProxy.getProjectsByUserIds(this.assignedUserIdFilter, ProjectType5.AllProjects,undefined, undefined, false).pipe(finalize(() => {
                })).toPromise();
                this.projectsData = res;
                this.projectIds = this.projectsData.map((team) => team.id);
                await this._userServiceProxy.getAllUsersUnderProject(this.projectIds).subscribe(async res => {
                    this.items = res;
                    if(this.items.length==0){
                        this.items = await this._commonCacheServiceProxy.filterByMemberData().toPromise();
                        this.items = this.items.filter(x=>x.id ==this._abpSessionService.userId);
                    }

                });
            }
            else{
                this.assignedUserIdFilter = [];
                this.projectsData = [];
                this.assignedUserIdFilter.push(this._abpSessionService.userId);
                this.multiselect =false;
                this.closeOnSelect = true;
                this.items = await this._commonCacheServiceProxy.filterByMemberData().toPromise();
                this.items = this.items.filter(x=>x.id ==this._abpSessionService.userId);
            this.selectedItems = this.items;
                this.change.emit(this.selectedItems);
            }

        }
        else{
            const isUserAdmin = this.userRoleArray.includes(ConstRoleName.Admin);

            if (isUserAdmin) {
                this.items = await this._commonCacheServiceProxy.filterByMemberData().toPromise();
                this.items.forEach(x=>{
                    x.roleNames = x.roleNames.map(x=>this.l(x));
                })
            }
        else {
            this.assignedUserIdFilter = [];
            this.projectsData = [];
            this.assignedUserIdFilter.push(this._abpSessionService.userId);
            let res = await this._projectServiceProxy.getProjectsByUserIds(this.assignedUserIdFilter, ProjectType5.AllProjects,undefined, undefined, false).pipe(finalize(() => {
            })).toPromise();
            this.projectsData = res;
            this.projectIds = this.projectsData.map((team) => team.id);
            await this._userServiceProxy.getAllUsersUnderProject(this.projectIds).subscribe( res => {
                this.items = res;
            });
        }
     }
     this.items = this.items.sort((a, b) => a.fullName.localeCompare(b.fullName));
    }

    emitSelection() {


        if (!this.selectedItems)
            return;
        if(this.selectedItemsLength!=undefined){
        this.selectedItemsLength = this.selectedItems?.length;
        if (this.selectedItems?.length != this.items?.length) {
            this.showselectall = true;
            this.showdeselectall = false;
        } else {
            this.showselectall = false;
            this.showdeselectall = true;
        }
    }
        this.change.emit(this.selectedItems);
        // document.getElementsByTagName("input")[0].value =null;
        //
    }

    selectAll() {

        this.selectedItems = this.items;
        this.showselectall = false;
        this.showdeselectall = true;
        this.change.emit(this.selectedItems)
    }



    unselectAll() {
        this.selectedItems = [];
        this.showselectall = true;
        this.showdeselectall = false;
        this.change.emit(this.selectedItems);
    }

    rearrangeItems() {
    }

    clearSelection() {
        this.selectedItems = undefined;
        this.change.emit(this.selectedItems);
    }

    customSearchFn(term: string, item: UserListDto) {
        return item.fullName.toLowerCase().indexOf(term.toLowerCase()) > -1 || item.emailAddress.toLowerCase().indexOf(term.toLowerCase()) > -1;
    }

    // checkUncheck(item) {
    //     item.selected = !item.selected;
    // }

    checkUncheck(item: any | undefined) {
        if (item && item.hasOwnProperty('selected')) {
          item.selected = !item.selected;
        }
      }


    setNoDataFound(value) {
        this.noDataFound = value;
    }

}
